// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0696a284","732":"ed62c77a","977":"0ebc619b"}[chunkId] + ".chunk.js";
};